/* TypeBox format registration.
 *
 * MUST be imported before any Value.Check() against a schema that uses `format`.
 * TypeBox does not ship format validators: an UNREGISTERED format makes
 * Value.Check return false, so a perfectly valid ISO timestamp is silently
 * rejected as a malformed request. Registering them here, once, in the shared
 * package means client, server and tests all agree on what "date-time" means.
 *
 * Ajv (used for Content Release validation) has its own formats via ajv-formats;
 * these registrations are for the TypeBox path only.
 */
import { FormatRegistry } from '@sinclair/typebox';
/** ISO-8601 UTC with milliseconds — the canonical ASCENT timestamp (04 §1.4). */
const ISO_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})$/;
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
function registerOnce(name, check) {
    if (!FormatRegistry.Has(name))
        FormatRegistry.Set(name, check);
}
registerOnce('date-time', (value) => ISO_DATE_TIME.test(value) && !Number.isNaN(Date.parse(value)));
registerOnce('date', (value) => ISO_DATE.test(value) && !Number.isNaN(Date.parse(value)));
// Regex rather than `new URL()`: this package is imported by the browser client
// too, so it must not depend on a Node-only global or a DOM lib.
const URI = /^[a-z][a-z0-9+.-]*:[^\s]*$/i;
registerOnce('uri', (value) => URI.test(value));
/* Any-version UUID, lowercase or upper. Registered because a schema that says
 * `format: 'uuid'` against an UNregistered format rejects every value — which is
 * how the Tutor's first message endpoint 422'd on a perfectly good id. */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
registerOnce('uuid', (value) => UUID.test(value));
export const REGISTERED_FORMATS = ['date-time', 'date', 'uri', 'uuid'];
//# sourceMappingURL=formats.js.map